/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import IconAdb from '../../../../../../Icon/IconAdb';
import IconAirlineSeatFlat from '../../../../../../Icon/IconAirlineSeatFlat';
import IconAirlineSeatFlatAngled from '../../../../../../Icon/IconAirlineSeatFlatAngled';
import IconAirlineSeatIndividualSuite from '../../../../../../Icon/IconAirlineSeatIndividualSuite';
import IconAirlineSeatLegroomExtra from '../../../../../../Icon/IconAirlineSeatLegroomExtra';
import IconAirlineSeatLegroomNormal from '../../../../../../Icon/IconAirlineSeatLegroomNormal';
import IconAirlineSeatLegroomReduced from '../../../../../../Icon/IconAirlineSeatLegroomReduced';
import IconAirlineSeatReclineExtra from '../../../../../../Icon/IconAirlineSeatReclineExtra';
import IconAirlineSeatReclineNormal from '../../../../../../Icon/IconAirlineSeatReclineNormal';
import IconBluetoothAudio from '../../../../../../Icon/IconBluetoothAudio';
import IconConfirmationNumber from '../../../../../../Icon/IconConfirmationNumber';
import IconDiscFull from '../../../../../../Icon/IconDiscFull';
import IconDoNotDisturb from '../../../../../../Icon/IconDoNotDisturb';
import IconDoNotDisturbAlt from '../../../../../../Icon/IconDoNotDisturbAlt';
import IconDoNotDisturbOff from '../../../../../../Icon/IconDoNotDisturbOff';
import IconDoNotDisturbOn from '../../../../../../Icon/IconDoNotDisturbOn';
import IconDriveEta from '../../../../../../Icon/IconDriveEta';
import IconEnhancedEncryption from '../../../../../../Icon/IconEnhancedEncryption';
import IconEventAvailable from '../../../../../../Icon/IconEventAvailable';
import IconEventBusy from '../../../../../../Icon/IconEventBusy';
import IconEventNote from '../../../../../../Icon/IconEventNote';
import IconFolderSpecial from '../../../../../../Icon/IconFolderSpecial';
import IconLiveTv from '../../../../../../Icon/IconLiveTv';
import IconMms from '../../../../../../Icon/IconMms';
import IconMore from '../../../../../../Icon/IconMore';
import IconNetworkCheck from '../../../../../../Icon/IconNetworkCheck';
import IconNetworkLocked from '../../../../../../Icon/IconNetworkLocked';
import IconNoEncryption from '../../../../../../Icon/IconNoEncryption';
import IconOndemandVideo from '../../../../../../Icon/IconOndemandVideo';
import IconPersonalVideo from '../../../../../../Icon/IconPersonalVideo';
import IconPhoneBluetoothSpeaker from '../../../../../../Icon/IconPhoneBluetoothSpeaker';
import IconPhoneForwarded from '../../../../../../Icon/IconPhoneForwarded';
import IconPhoneInTalk from '../../../../../../Icon/IconPhoneInTalk';
import IconPhoneLocked from '../../../../../../Icon/IconPhoneLocked';
import IconPhoneMissed from '../../../../../../Icon/IconPhoneMissed';
import IconPhonePaused from '../../../../../../Icon/IconPhonePaused';
import IconPower from '../../../../../../Icon/IconPower';
import IconPriorityHigh from '../../../../../../Icon/IconPriorityHigh';
import IconRvHookup from '../../../../../../Icon/IconRvHookup';
import IconSdCard from '../../../../../../Icon/IconSdCard';
import IconSimCardAlert from '../../../../../../Icon/IconSimCardAlert';
import IconSms from '../../../../../../Icon/IconSms';
import IconSmsFailed from '../../../../../../Icon/IconSmsFailed';
import IconSync from '../../../../../../Icon/IconSync';
import IconSyncDisabled from '../../../../../../Icon/IconSyncDisabled';
import IconSyncProblem from '../../../../../../Icon/IconSyncProblem';
import IconSystemUpdate from '../../../../../../Icon/IconSystemUpdate';
import IconTapAndPlay from '../../../../../../Icon/IconTapAndPlay';
import IconTimeToLeave from '../../../../../../Icon/IconTimeToLeave';
import IconVibration from '../../../../../../Icon/IconVibration';
import IconVoiceChat from '../../../../../../Icon/IconVoiceChat';
import IconVpnLock from '../../../../../../Icon/IconVpnLock';
import IconWc from '../../../../../../Icon/IconWc';
import IconWifi from '../../../../../../Icon/IconWifi';

export default function NotificationIcons() {
  return (
    <div>
      <CategoryHeader>notification</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <IconAdb size="32"/>
          <FigCaption>
            IconAdb
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAirlineSeatFlat size="32"/>
          <FigCaption>
            IconAirlineSeatFlat
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAirlineSeatFlatAngled size="32"/>
          <FigCaption>
            IconAirlineSeatFlatAngled
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAirlineSeatIndividualSuite size="32"/>
          <FigCaption>
            IconAirlineSeatIndividualSuite
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAirlineSeatLegroomExtra size="32"/>
          <FigCaption>
            IconAirlineSeatLegroomExtra
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAirlineSeatLegroomNormal size="32"/>
          <FigCaption>
            IconAirlineSeatLegroomNormal
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAirlineSeatLegroomReduced size="32"/>
          <FigCaption>
            IconAirlineSeatLegroomReduced
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAirlineSeatReclineExtra size="32"/>
          <FigCaption>
            IconAirlineSeatReclineExtra
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAirlineSeatReclineNormal size="32"/>
          <FigCaption>
            IconAirlineSeatReclineNormal
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBluetoothAudio size="32"/>
          <FigCaption>
            IconBluetoothAudio
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconConfirmationNumber size="32"/>
          <FigCaption>
            IconConfirmationNumber
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDiscFull size="32"/>
          <FigCaption>
            IconDiscFull
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDoNotDisturb size="32"/>
          <FigCaption>
            IconDoNotDisturb
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDoNotDisturbAlt size="32"/>
          <FigCaption>
            IconDoNotDisturbAlt
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDoNotDisturbOff size="32"/>
          <FigCaption>
            IconDoNotDisturbOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDoNotDisturbOn size="32"/>
          <FigCaption>
            IconDoNotDisturbOn
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDriveEta size="32"/>
          <FigCaption>
            IconDriveEta
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconEnhancedEncryption size="32"/>
          <FigCaption>
            IconEnhancedEncryption
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconEventAvailable size="32"/>
          <FigCaption>
            IconEventAvailable
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconEventBusy size="32"/>
          <FigCaption>
            IconEventBusy
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconEventNote size="32"/>
          <FigCaption>
            IconEventNote
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFolderSpecial size="32"/>
          <FigCaption>
            IconFolderSpecial
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLiveTv size="32"/>
          <FigCaption>
            IconLiveTv
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMms size="32"/>
          <FigCaption>
            IconMms
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMore size="32"/>
          <FigCaption>
            IconMore
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNetworkCheck size="32"/>
          <FigCaption>
            IconNetworkCheck
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNetworkLocked size="32"/>
          <FigCaption>
            IconNetworkLocked
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNoEncryption size="32"/>
          <FigCaption>
            IconNoEncryption
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconOndemandVideo size="32"/>
          <FigCaption>
            IconOndemandVideo
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPersonalVideo size="32"/>
          <FigCaption>
            IconPersonalVideo
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhoneBluetoothSpeaker size="32"/>
          <FigCaption>
            IconPhoneBluetoothSpeaker
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhoneForwarded size="32"/>
          <FigCaption>
            IconPhoneForwarded
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhoneInTalk size="32"/>
          <FigCaption>
            IconPhoneInTalk
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhoneLocked size="32"/>
          <FigCaption>
            IconPhoneLocked
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhoneMissed size="32"/>
          <FigCaption>
            IconPhoneMissed
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhonePaused size="32"/>
          <FigCaption>
            IconPhonePaused
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPower size="32"/>
          <FigCaption>
            IconPower
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPriorityHigh size="32"/>
          <FigCaption>
            IconPriorityHigh
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRvHookup size="32"/>
          <FigCaption>
            IconRvHookup
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSdCard size="32"/>
          <FigCaption>
            IconSdCard
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSimCardAlert size="32"/>
          <FigCaption>
            IconSimCardAlert
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSms size="32"/>
          <FigCaption>
            IconSms
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSmsFailed size="32"/>
          <FigCaption>
            IconSmsFailed
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSync size="32"/>
          <FigCaption>
            IconSync
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSyncDisabled size="32"/>
          <FigCaption>
            IconSyncDisabled
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSyncProblem size="32"/>
          <FigCaption>
            IconSyncProblem
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSystemUpdate size="32"/>
          <FigCaption>
            IconSystemUpdate
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTapAndPlay size="32"/>
          <FigCaption>
            IconTapAndPlay
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTimeToLeave size="32"/>
          <FigCaption>
            IconTimeToLeave
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVibration size="32"/>
          <FigCaption>
            IconVibration
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVoiceChat size="32"/>
          <FigCaption>
            IconVoiceChat
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVpnLock size="32"/>
          <FigCaption>
            IconVpnLock
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWc size="32"/>
          <FigCaption>
            IconWc
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWifi size="32"/>
          <FigCaption>
            IconWifi
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/NotificationIcons.js